function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_769",
  "data-name": "Group 769",
  transform: "translate(0 -26)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_27",
  "data-name": "Group 27",
  transform: "translate(0 26)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_306",
  "data-name": "Path 306",
  d: "M829.133,1944.266a35.133,35.133,0,1,1,35.133-35.133A35.171,35.171,0,0,1,829.133,1944.266Zm0-63.239a28.106,28.106,0,1,0,28.106,28.106A28.138,28.138,0,0,0,829.133,1881.027Z",
  transform: "translate(-794 -1874)",
  fill: "#ff1919"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_28",
  "data-name": "Group 28",
  transform: "translate(30.563 40.625)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_126",
  "data-name": "Rectangle 126",
  width: 10,
  height: 24,
  transform: "translate(-0.459 -0.439)",
  fill: "#ff1919"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_29",
  "data-name": "Group 29",
  transform: "translate(30.741 68.794)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_6",
  "data-name": "Ellipse 6",
  cx: 4.392,
  cy: 4.392,
  r: 4.392,
  fill: "#ff1919"
})));

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.265,
    height: 70.266,
    viewBox: "0 0 70.265 70.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.dbe68d72.svg";
export { ForwardRef as ReactComponent };